<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import useChatStore from '@/stores/communication/chat';
import Conversation from '@/stores/communication/Conversation';
import ChatWindow from '@/views/communication/components/ChatWindow.vue';
import useConversationsStore from '@/stores/communication/conversations';

const route = useRoute();
const uuid = String(route.params.uuid);

const convStore = useConversationsStore();
const chatStore = useChatStore();

const conversation = ref<Conversation>();

async function loadConversation() {
	conversation.value = await convStore.fetchConversation(uuid);
	// load participants label
}

onMounted(async () => {
	await convStore.fetchConversations();
	await loadConversation();

	console.log('Loaded conversation:', conversation.value);
});

// helpers
const conversationTypeLabel = computed(() =>
	conversation.value?.type === 'group' ? 'Group chat' : 'Direct chat'
);

const participantsLabel = computed(() => {
	if (!conversation.value) return '';
	return conversation.value.participants
		?.map((p: any) => `${p?.first_name} ${p?.last_name}` || p.user?.email)
		.join(', ');
});

function refresh() {
	loadConversation();
}
</script>

<template>
	<v-container fluid class="pa-4">
		<v-card>
			<v-card-title>
				<div class="d-flex align-center">
					<div class="text-h6">
						<v-icon color="teal">mdi-account-circle</v-icon>
						{{ conversation?.display_name || conversationTypeLabel }}
					</div>
					<!-- <div class="text-caption">{{ participantsLabel }}</div> -->
					<v-spacer />
					<v-btn
						@click="refresh"
						icon="mdi-refresh"
						variant="plain"
						size="small"
					/>
				</div>
			</v-card-title>

			<v-divider />

			<ChatWindow :uuid="uuid" :display-name="null" />
		</v-card>
	</v-container>
</template>
